function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7 1.425a.408.408 0 00-.125-.3L6.708.958a.417.417 0 00-.591 0L3.167 3.9a.425.425 0 000 .592l2.95 2.941a.417.417 0 00.591 0l.167-.166a.408.408 0 00.125-.3V5a5 5 0 015 5 4.95 4.95 0 01-.575 2.317.417.417 0 00.075.491l.608.609a.417.417 0 00.35.116.433.433 0 00.309-.2A6.667 6.667 0 007 3.333V1.425zm.587 11.018c.112 0 .218.045.296.124l2.95 2.941c.16.165.16.427 0 .592l-2.95 2.942a.417.417 0 01-.591 0l-.167-.167a.408.408 0 01-.125-.3v-1.908a6.667 6.667 0 01-5.767-10 .433.433 0 01.309-.217.417.417 0 01.35.117l.616.616c.129.131.159.33.075.492A4.858 4.858 0 002 10a5 5 0 005 5v-1.967a.408.408 0 01.125-.3l.167-.166a.417.417 0 01.295-.124z"
});

var SvgSync = function SvgSync(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "1 1 12 18",
    fill: "#9193A9"
  }, props), _ref);
};

export default SvgSync;